import { createFormHook } from "@tanstack/react-form";
import { fieldContext, formContext } from "./formContext";
import { NumberField } from "./NumberField";
import { SelectField } from "./SelectField";
import { TextareaField } from "./TextareaField";
import { HeaderActions } from "./HeaderActions";

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    NumberField,
    SelectField,
    TextareaField,
  },
  formComponents: {
    HeaderActions,
  },
});
